import isDocument from './isDocument';
import isWindow from './isWindow';
/**
 * Get the current computed inner height, including padding but not
 * border, for the specified node.
 *
 * If the `window` object is provided, returns the height of the browser
 * window viewport excluding, if rendered, the horizontal scrollbar
 * height.
 *
 * If the `document` object is provided, returns the height of the
 * rendered document including content not visible in the browser window
 * viewport.
 *
 * @param element
 */

export default function getInnerHeight(target) {
  if (isWindow(target)) {
    return target.document.documentElement.clientHeight;
  }

  if (isDocument(target)) {
    // Either scrollHeight or offsetHeight or clientHeight,
    // whichever is greatest.
    return Math.max(target.body.scrollHeight, target.documentElement.scrollHeight, target.body.offsetHeight, target.documentElement.offsetHeight, target.documentElement.clientHeight);
  }

  return target.clientHeight;
}
//# sourceMappingURL=getInnerHeight.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/browser-helpers/dist/esm/getInnerHeight.js
// module id = 506
// module chunks = 0 1